import {option, Option} from "ts-option";
import * as React from "react";
import Modal from "../../../ui/modal/Modal";
import FormButtonsView from "../../../ui/form/FormButtonsView";
import UserMention from "../../../mention/UserMention";
import {IMentionData} from "react-mentions";
import ButtonPrimary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import ButtonTertiary from "../../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";

interface IComponentProps {
	/**
	 * Lead desciption value
	 */
	value: Option<string>;
	/**
	 * Title for modal.
	 */
	title?: string;
	/**
	 * Description change callback
	 * @param {Option<string>} value
	 */
	onChange: (value: Option<string>, mentions: IMentionData[]) => void;
	/**
	 * CLose modal callback
	 */
	onClose: () => void;
}

interface IState {
	/**
	 * Temporary description  value
	 */
	tmpValue: string;
	/**
	 * Mentions in description
	 */
	mentions: IMentionData[];
}

type Props = IComponentProps

export default class DescriptionModal extends React.PureComponent<Props, IState> {

	public static defaultProps: Partial<Props> = {
		title: "Lead description"
	};

	constructor(props: Props) {
		super(props);
		this.state =
			{tmpValue: this.props.value.getOrElse(""), mentions: []};
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onClose} title={this.props.title}>
				<UserMention onChange={(event, mentions) => {this.setState({tmpValue: event.target.value, mentions: mentions})}}
							 value={this.state.tmpValue}
							 minHeight={150}
							 hasBorder
							 className={"lead-description"}/>
				<FormButtonsView align={"right"}>
					<div style={{paddingTop: "20px", marginTop: "70px"}}>
						<div className="pull-left">
							<ButtonTertiary label="Cancel"
											onClick={this.props.onClose}/>
						</div>
						<ButtonPrimary label={"Change"}
									   onClick={() => this.props.onChange(option(this.state.tmpValue), this.state.mentions)}/>
					</div>
				</FormButtonsView>
			</Modal>
		)
	}


}